/**
 * 데이터 형식
{
  date: '', //YYYY-MM-DD
  items: [ // 변경 유형 별 객체 배열
    {
      type: '', // 변경 유형(신규/버전 추가: 'Added', 변경: 'Changed', 버그 수정: 'Fixed', 미지원: 'Removed', 문서 수정:'Docs')
      summary: <></>, // 변경 내용 요약
      apis: [ // 변경 유형에 해당하는 API 배열, 변경사항이 전체 적용인경우(ex.에러 응답 포맷 변경) 빈배열도 가능
          {
            authorized_sol_ser: '',  // 권한별 노출, 필요없다면 제거 (주문금액분할모듈업체: 'cal_state_per_prod')
            method: '',
            action: '',
            detail: <></> // API 별 상세 설명, 필요없다면 제거
          }
      ]
    },
  ]
}
*/

const release2026 = [
  {
    date: '2026-02-25',
    items: [
      {
        type: 'Changed',  
        summary:
        <>
          SKU상품-리스트 조회/상세조회/등록, 세트상품-조회/등록 API 파라미터 출고 리드타임 <code>out_leadtime</code> 추가
        </>,
        apis: [
          {
            method: 'POST',
            action: '/stock/set-add',
          },
          {
            method: 'POST',
            action: '/stock/sets',
          },
          {
            method: 'POST',
            action: '/stock/add',
          },
          {
            method: 'GET',
            action: '/stock/:sku_cd',
          },
          {
            method: 'POST',
            action: '/stock/list',
          }
        ]
      }
    ]
  },
  {
    date: '2026-02-12',
    items: [
      {
        type: 'Changed',
        summary: 
        <>
          주문 리스트조회 API Response 귀책 구분 <code>claim_fault_type</code> 추가
        </>,
        apis: [
          {
            method: 'POST',
            action: '/orders',
          }
        ]
      }
    ]
  },
  {
    date: '2026-02-11',
    items: [
      {
        type: 'Added',
        summary:
        <>
          선택작업 등록 API v1.1 추가
        </>,
        apis: [
          {
            method: 'POST',
            action: '/work/addWorkSelect/v1.1',
            detail: 
            <>
              v1.0 버전과의 차이점<br/>
              - 쇼핑몰 상품 연동 작업시 호출하는 파라미터에 <code>shop_cd, shop_id, std_ol_yn</code> 제거.<br/>
              - 쇼핑몰 상품 연동 작업시 list 파라미터에 <code>c_sale_cd</code> 가 아닌 <code>ol_shop_no</code> 사용<br/>
              - 나머지는 v1.0 과 동일
            </>
          }
        ]
      }
    ]
  },
  {
    date: '2026-02-02',
    items: [
      {
        type: 'Changed',
        summary:
        <>
          배송정보 업데이트 API 파라미터 검증 강화
        </>,
        apis: [
          {
            method: 'PUT',
            action: '/order/setInvoice',
            detail:
            <>
              - 배송정보 업데이트 API 요청 시 orders 내부 타입이 유효하지 않은 경우 오류가 반환되도록 개선되었습니다.
            </>
          }
        ]
      }
    ]
  },
  {
    date: '2026-01-21',
    items: [
      {
        type: 'Changed',
        summary:
        <>
          주문상태변경 API 상태 변경 가능 조건 확장
        </>,
        apis: [
          {
            method: 'PATCH',
            action: '/orders/status',
            detail:
            <>
              - <strong>배송중</strong> : 현재 주문상태가 [주문재확인, <strong>출고완료</strong>]인 경우 변경 가능<br/>
            </>
          }
        ]
      }
    ]
  }
]

export default release2026;